/** @format */

import {Link} from 'react-router-dom';
import React from 'react';

export const OrderIdColumn = props => {
    const {order} = props;
    return (
        <div className="single-active-order-10cn__column--id">
            <Link
                to={'/account/orders/view/' + order.id}
                target="_blank"
                rel="noopener noreferrer"
                className="d-inline-flex align-items-center justify-content-start gap-2 color-accent-primary">
                <i className="fa fa-eye" style={{fontSize: '16px'}} />
                <u>{order.label}</u>
            </Link>
        </div>
    );
};
